import { Card, CardContent, Typography, Grid } from "@mui/material";
import { useSelector } from "react-redux";

export default function ClientO365() {

    const { data: o365Licenses = [], o365LicensesLoading, o365LicensesError } = useSelector((state) => state.o365.licenses);
    const { data: o365Users = [], o365UsersLoading, o365UsersError } = useSelector((state) => state.o365.users);
    
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6">Licences O365</Typography>
            <Typography variant="body2">
              Vous avez {o365Licenses.length} licences actives.
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6">Utilisateurs</Typography>
            <Typography variant="body2">{o365Users.length} comptes</Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
